// extracted by mini-css-extract-plugin
export default {"contentPage":"ContentPage_contentPage__KpVkZ","content":"ContentPage_content__j4HjJ","loading":"ContentPage_loading__IS2JT","error":"ContentPage_error__-eKvT"};